import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/authStore";

export function RegistrationLogoutButton() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="gap-2"
      onClick={handleLogout}
    >
      <LogOut className="h-4 w-4" />
      Sair
    </Button>
  );
}
